import Link from 'next/link';
import styled from 'styled-components';

import {
  buttonCss,
  ButtonStyleProps
} from '@/components/ui/Button/Button.styles';
import { CONTAINER_BREAKPOINTS, CONTAINER_MAX } from '@/constants/breakpoints';
import { Z_INDEX } from '@/constants/z-index';
import { flexColumn } from '@/styles/common';

import { Typography } from '../ui/Typography/Typography.styles';

export const ContentWrapper = styled.div`
  ${flexColumn};
  align-items: center;
  overflow-y: hidden;

  height: 100vh;
  margin-inline: auto;
  justify-content: center;
  margin-top: -4%;
  padding: 0 40px;

  @media (max-width: ${CONTAINER_MAX.tabletL}) {
    padding: 0 24px;
  }

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    padding: 0 16px;
    margin-top: -30%;
  }
`;

export const Title = styled(Typography).attrs({ variant: 'h1' })`
  font-size: 160px;
  text-align: center;
  color: var(--textAndLabels-main);
  margin-bottom: 10px;

  @media (max-width: ${CONTAINER_MAX.tabletL}) {
    font-size: 80px;
  }
`;

export const Text = styled(Typography).attrs({ variant: 'title1' })`
  text-align: center;
  color: var(--textAndLabels-main);
  margin-bottom: 40px;
  z-index: 100;

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    font-size: 16px;
    font-weight: 500;
  }
`;

export const Waves = styled.div`
  position: fixed;
  pointer-events: none;
  left: 0;
  bottom: 0;
  background-image: url('/images/waves.png');
  height: 520px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    background-position: bottom 0 left -90px;
  }

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    background-position: bottom 0 left -120px;
  }

  @media (min-width: ${CONTAINER_BREAKPOINTS.desktopXL}) {
    margin-top: -712px;
    height: 712px;
  }
`;

export const GoHomeLink = styled(Link)<ButtonStyleProps>`
  ${buttonCss};
  z-index: ${Z_INDEX.DEFAULT};
`;

export const HeaderWrapper = styled.div`
  @media (max-width: ${CONTAINER_MAX.tabletL}) {
    display: none;
  }
`;
